class FacilityReportingGridService {

    constructor(
        $http,
        appConfig
    ) {
        'ngInject';

        this.$http = $http;
        this.appConfig = appConfig;
    }


    /***
     * Get the Facility Data report for the given combination of clients and year.
     *
     * @param clientIds     a comma-separated list of client IDs
     * @param year          the year of reports to pull
     */
    getReport(clientIds, year) {
        const config = {
            params: {
                clients: clientIds,
                year: year
            }
        };

        return this.$http.get(`${this.appConfig.apiUrl}/stats/report/`, config)
            .then((successResponse) => successResponse.data);
    }

}

export default FacilityReportingGridService;


// WEBPACK FOOTER //
// ./app/components/facility-reporting/facility-reporting-grid/facility-reporting-grid-service.js